import axios from 'axios'
import router from '../router'
import ElementUI from 'element-ui'
const http = axios.create({
  timeout: 50000,
  baseURL: process.env.BASE_FRONT_URL
})

// 请求拦截
http.interceptors.request.use(config => {
  if (localStorage.getItem('token')) {
    config.headers['Authorization'] = 'Bearer ' + localStorage.getItem('token')
  }
  config.headers['Content-Type'] = 'application/json'
  return config
}, error => {
  Promise.reject(error)
})

//
http.interceptors.response.use(res => {
  if (res.status === 200) {
    if (res.data.status === 2001) {
      return res.data
    } else if (res.data.status === 4003) {
      setTimeout(() => {
        localStorage.removeItem('token')
        localStorage.removeItem('userInfo')
        router.push({name: 'login'})
      }, 800)
    }
    return res.data
  } else {
    ElementUI.Notification.error('服务器错误')
  }
}, error => {
  ElementUI.Notification.error('服务器错误')
  setTimeout(() => {
    return Promise.reject(error)
  }, 1000)
})

export default http



// WEBPACK FOOTER //
// ./src/api/config.js